<div
  class="modal-fundo modal-novo-usuario"
  [style.display]="mostrarModal ? '' : 'none'"
>
  <div class="modal-conteudo">
    <div class="modal-cabecalho">
      <h5 class="modal-titulo">
        {{ !usuario ? "Novo Usuário" : "Editar Usuário" }}
      </h5>
      <button class="modal-fechar" (click)="fechar()" type="button">&times;</button>
    </div>
    <div class="modal-corpo">
      <div class="modal-content">
        <form
          [formGroup]="usuarioForm"
          (ngSubmit)="salvarUsuario()"
          autocomplete="off"
        >
          <div class="modal-body">
            <div class="row">
              <div class="col-6 mb-2">
                <label class="form-label-usuario">Nome</label>
                <input
                  class="form-control form-control-lg"
                  id="nome"
                  name="nome"
                  placeholder="Nome *"
                  formControlName="nome"
                  required="True"
                  type="text"
                />
              </div>
              <div class="col-6 mb-2">
                <label class="form-label-usuario">E-mail</label>
                <input
                  class="form-control form-control-lg"
                  id="email"
                  name="email"
                  placeholder="E-mail *"
                  formControlName="email"
                  (input)="onInputEmail($event)"
                  (blur)="validarEmail()"
                  required="True"
                  type="email"
                />
                <div *ngIf="emailInvalido" class="text-danger">
                  Este e-mail já está em uso. Por favor, escolha outro.
                </div>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-12">
                <label class="form-label-usuario">Login</label>
                <input
                  class="form-control form-control-lg"
                  id="login"
                  name="login"
                  placeholder="Login *"
                  formControlName="login"
                  required="True"
                  type="text"
                />
              </div>
            </div>
            <div class="row mb-3">
              <div class="col" style="min-width: 302px">
                <div class="form-check form-switch">
                  <label class="switch">
                    <input
                      class="slider-novo-usuario"
                      type="checkbox"
                      formControlName="ativo"
                    />
                    <span class="slider"></span>
                  </label>
                  <label class="form-check-label" for="itemAtivo">
                    Cadastrar com status
                    <span
                      *ngIf="usuarioForm.get('ativo')?.value"
                      class="highlight"
                      id="status"
                      style="color: #27dead"
                      >ativo
                    </span>
                    <span
                      *ngIf="!usuarioForm.get('ativo')?.value"
                      class="highlight"
                      id="status"
                      style="color: red"
                      >inativo
                    </span>
                  </label>
                </div>
              </div>
              <div class="col" style="max-width: 33%">
                <div class="form-check form-switch">
                  <label class="switch">
                    <input
                      class="slider-novo-usuario"
                      type="checkbox"
                      formControlName="acessoSimultaneo"
                    />
                    <span class="slider"></span>
                  </label>
                  <label class="form-check-label" for="acessoMultiplo"
                    >Acesso Simultâneo</label
                  >
                </div>
              </div>
              <div class="col" style="max-width: 33%">
                <div class="form-check form-switch">
                  <label class="switch">
                    <input
                      class="slider-novo-usuario"
                      type="checkbox"
                      formControlName="acessoCelular"
                    />
                    <span class="slider"></span>
                  </label>
                  <label class="form-check-label" for="acessoCelular"
                    >Acesso Celular</label
                  >
                </div>
              </div>
              <div class="col" style="max-width: 33%">
                <div class="form-check form-switch">
                  <label class="switch">
                    <input
                      class="slider-novo-usuario"
                      type="checkbox"
                      formControlName="acessoExpira"
                    />
                    <span class="slider"></span>
                  </label>
                  <label class="form-check-label" for="acessoExpira"
                    >Acesso Expira</label
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div class="password-wrapper">
                  <label class="form-label-usuario">Senha</label>
                  <div class="input-container">
                    <input
                      class="form-control form-control-lg"
                      id="password"
                      name="novaSenha"
                      formControlName="senha"
                      minlength="6"
                      maxlength="20"
                      pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}"
                      placeholder="Senha"
                      type="password"
                    />
                    <button class="toggle-password" type="button">
                      <span
                        class="material-symbols-outlined"
                        (click)="toggleVisualizarSenha('password')"
                        >visibility</span
                      >
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="password-wrapper">
                  <label class="form-label-usuario">Confirmação da senha</label>
                  <div class="input-container">
                    <input
                      class="form-control form-control-lg"
                      id="repeat-password"
                      name="confirmarSenha"
                      placeholder="Confirmar Senha"
                      type="password"
                      formControlName="confirmarSenha"
                    />
                    <button class="toggle-password" type="button">
                      <span
                        class="material-symbols-outlined"
                        (click)="toggleVisualizarSenha('repeat-password')"
                        >visibility</span
                      >
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div class="row">
                  <div class="col">
                    <label class="form-label-usuario"
                      >Data Expiração Acesso</label
                    >
                    <input
                      class="form-control form-control-lg"
                      data-initialvalue=""
                      id="finalDate"
                      formControlName="dataExpiracao"
                      name="dataExpira"
                      placeholder="Vencimento de senha (em dias)"
                      type="date"
                      [min]="dataAtual"
                    />
                  </div>
                  <div style="align-content: end" class="col-auto">
                    <button
                      type="button"
                      class="btn btn-primary btn-dias"
                      id="btn-definir-dias"
                      style="bottom: 0"
                      [disabled]="!usuarioForm.get('acessoExpira')?.value"
                      (click)="abrirDefinirDiasModal()"
                    >
                      Definir em Dias
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-6" style="align-content: end">
                <label style="font-size: 12px; color: orangered"
                  >Regras para criação da senha:
                </label>
                <ul style="padding-left: 9px; font-size: 12px; column-count: 2">
                  <li style="list-style: initial">Pelo menos 6 caracteres</li>
                  <li style="list-style: initial">
                    Ao menos uma letra maiúscula
                  </li>
                  <li style="list-style: initial">
                    Ao menos uma letra minúscula
                  </li>
                  <li style="list-style: initial">
                    Ao menos um caractere especial
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex gap-3">
            <button type="button" class="btn btn-secondary" (click)="fechar()" type="button">
              Cancelar</button
            ><button
              id="salvaUsuarios"
              type="submit"
              class="btn btn-primary"
              [disabled]="salvandoUsuario"
              style="padding-left: 25px; padding-right: 25px"
            >
              <span *ngIf="!salvandoUsuario">Salvar</span>
              <span *ngIf="salvandoUsuario">Salvando...</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div
  class="modal-fundo modal-definir-dias"
  [style.display]="mostrarDefinirDiasModal ? 'flex' : 'none'"
>
  <div class="modal-conteudo">
    <div class="modal-cabecalho">
      <h3 class="modal-titulo">Definir Dias de Vencimento</h3>
      <button class="modal-fechar" (click)="fecharDefinirDiasModal()">&times;</button>
    </div>
    <div class="modal-corpo">
      <div class="form-grupo">
        <label for="qtd-dias" class="form-label">Quantidade de dias:</label>
        <input
          type="number"
          id="qtd-dias"
          class="form-input"
          [(ngModel)]="diasDefinidos"
          min="1"
        />
      </div>
      <div class="info-texto">
        Data atual: <span>{{ obterDataAtual("dd/mm/yyyy") }}</span>
      </div>
      <div class="info-texto">
        Data resultante: <span>{{ calcularDataResultante() }}</span>
      </div>
    </div>
    <div class="modal-rodape">
      <button class="btn-cancelar" (click)="fecharDefinirDiasModal()">Cancelar</button>
      <button id="btn-aplicar" class="btn-aplicar" (click)="aplicarDias()">Aplicar</button>
    </div>
  </div>
</div>